import { tuple } from './type';
export const PresetStatusColorTypes = tuple('success', 'processing', 'error', 'default', 'warning');
// eslint-disable-next-line import/prefer-default-export
export const PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime', 'dark', 'gray');
// eslint-disable-next-line import/prefer-default-export
export function isPresetColor(color) {
    color = color ? color.replace(/(-inverse$)/g, '') : color;
    return PresetColorTypes.indexOf(color) !== -1;
}
